import React from 'react'
import {Paper, FormLabel, Grid, TextField, Button, CircularProgress} from '@material-ui/core'
import {Save, Edit, Cancel} from "@material-ui/icons";
import classNames from 'classnames';


export default function PersonalInfo(props) {
    const {personalInfo} = props.allState;
    const {infoChange, cancelInfoChange, submitInfoChange} = props;
    const {isInfoChg} = props.allProps;

    return (
        <Grid item>
            <Paper className={props.classes.paper} style={{'height': 'auto'}}>
                <FormLabel component="legend">Personal Information</FormLabel>

                <Grid container spacing={24}>
                    <Grid item xs={6}>
                        <TextField
                            id="outlined-name"
                            label="First Name"
                            name='given_name'
                            className={props.classes.textField}
                            value={personalInfo.given_name}
                            fullWidth
                            onChange={infoChange}
                            margin="dense"
                            variant="outlined"
                            disabled={props.allState.InfoEdit}
                        />
                    </Grid>
                    <Grid item xs={6}>
                        <TextField
                            id="outlined-name"
                            label="Last Name"
                            name='family_name'
                            className={props.classes.textField}
                            value={personalInfo.family_name}
                            onChange={infoChange}
                            fullWidth
                            margin="dense"
                            variant="outlined"
                            disabled={props.allState.InfoEdit}
                        />
                    </Grid>
                </Grid>

                <TextField
                    id="outlined-name"
                    label="Email"
                    name="email"
                    className={props.classes.textField}
                    value={personalInfo.email}
                    onChange={infoChange}
                    fullWidth
                    margin="dense"
                    variant="outlined"
                    disabled={props.allState.InfoEdit}
                />

                <TextField
                    id="outlined-name"
                    label="Mobile#"
                    name="phone_number"
                    className={props.classes.textField}
                    value={personalInfo.phone_number}
                    onChange={infoChange}
                    fullWidth
                    margin="dense"
                    variant="outlined"
                    disabled={props.allState.InfoEdit}
                />

                <TextField
                    id="outlined-name"
                    label="NIC#"
                    name="custom:nic"
                    className={props.classes.textField}
                    value={personalInfo['custom:nic']}
                    onChange={infoChange}
                    fullWidth
                    margin="dense"
                    variant="outlined"
                    disabled={props.allState.InfoEdit}
                />

                <Grid container direction="row" justify="flex-end" alignItems="flex-start" spacing={8} style={{'paddingTop': '10px'}}>

                    {isInfoChg ?
                        <CircularProgress className={props.classes.progress} size={21}/>
                        :
                        <div>
                            {
                                props.allState.InfoEdit ?
                                    <Grid item>
                                        <Button variant="contained" color="default" size="small"
                                                onClick={props.stateChanger}
                                                className={props.classes.button}>
                                            <Edit className={classNames(props.classes.leftIcon, props.classes.iconSmall)}/>
                                            Edit
                                        </Button>
                                    </Grid>
                                    :
                                    <Grid item>
                                        <Grid
                                            container
                                            direction="row"
                                            justify="flex-end"
                                            alignItems="flex-start"
                                            spacing={8}
                                        >
                                            <Grid item>
                                                <Button variant="contained" color="secondary" size="small"
                                                        onClick={submitInfoChange}
                                                        className={props.classes.button}>
                                                    <Save
                                                        className={classNames(props.classes.leftIcon, props.classes.iconSmall)}/>
                                                    Update
                                                </Button>
                                            </Grid>
                                            <Grid item>
                                                <Button variant="contained" color="primary" size="small"
                                                        onClick={cancelInfoChange}
                                                        className={props.classes.button}>
                                                    <Cancel
                                                        className={classNames(props.classes.leftIcon, props.classes.iconSmall)}/>
                                                    Cancel
                                                </Button>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                            }
                        </div>
                    }
                </Grid>
            </Paper>
        </Grid>
    )
}
